/* @component id="auth-button" name="AuthButton" type="ui-auth" version="2.0.0" */
"use client";

import { signIn } from "next-auth/react";
import { Button } from "../ui/button";

export default function AuthButton() {
  return (
    <Button className="w-full" onClick={() => signIn("azure-ad")}>
      Sign in
    </Button>
  );
}
